<template>
  <div>
    <a-row>
      <g-master name="project"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="parentData"
                modalWidth="80%"
      >
            <span slot="estadoRenderer" slot-scope="{text}">
              <a-tag :color="text==='PENDIENTE' ? 'red' : (text === 'COMPLETO' ? 'green' : 'blue')">{{text}}</a-tag>
            </span>
        <template slot="expandedRowRender" slot-scope="{text}">
          <template v-for="ve in master.valoresExpandidos">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </template>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Nombre')">
                <a-input class="ant-uppercase"
                  v-decorator="['task_name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Descripción')">
                <a-textarea autoSize
                  v-decorator="['task_description', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Prioridad')"
                          :formItemConfig="fiOptions"
                          :decorator="['task_priority', { rules: [{ required: false }] }]"
                          :params="prioridad_tarea">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Fecha inicio')">
                <a-date-picker style="width: 100%" valueFormat="Y-MM-DD 00:00:00"
                               v-decorator="['ini_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                ></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Fecha fin')">
                <a-date-picker style="width: 100%" valueFormat="Y-MM-DD 00:00:00"
                               v-decorator="['end_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                ></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Estado')"
                          :formItemConfig="fiOptions"
                          :decorator="['id_h_status_task', { rules: [{ required: false }] }]"
                          :params="estado_tarea">
              </g-dropdown>
            </a-col>
          </a-row>
        </template>
      </g-master>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane :tab="$t('DETALLES DE LA TAREA')" key="1">
          <project_task_details v-if="idTask" :id_project_task="idTask"></project_task_details>
          <span v-else>Seleccione una tarea para ver más.</span>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        prioridad_tarea: {
          h_lookup_type: 'GP_PRIORIDAD_TAREA',
          use_description: true
        },
        estado_tarea: {
          h_lookup_type: 'GP_ESTADO_PROYECTOYTAREAS'
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado el', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado el', column: 'modified_on'}
          ],
          actions: {
            actions: [
              {
                name: 'masterEdit',
                text: 'Editar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'edit'}
              },
              {
                name: 'masterDelete',
                text: 'Eliminar',
                permisos: [],
                props: {size: 'small', icon: 'delete', type: 'link'}
              }
            ]
          },
          endpoint: 'project_tasks',
          tableSetup: {
            customSlots: ['estadoRenderer', 'expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Tarea', dataIndex: 'task_name', sorter: true, width: 400},
              {title: 'Descripción', dataIndex: 'task_description', sorter: true, width: 400},
              {title: 'Prioridad', dataIndex: 'task_priority', sorter: true, width: 120},
              {title: 'Fecha Inicio', dataIndex: 'f_ini', sorter: true},
              {title: 'Fecha Fin', dataIndex: 'f_fin', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                width: 105,
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              }
            ],
            allowSelect: true,
            selectedRows: []
          }
        }
      }
    },
    props: ['project_id'],
    computed: {
      parentData () {
        return {
          project_id: this.project_id
        }
      },
      idTask () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/GestionDeProyectos/ProjectTasks.vue